import type { EventoMeu, StatusEvento } from './types';

export const STATUS_EVENTO_CONFIG: Record<StatusEvento, { rotulo: string; classes: string }> = {
  rascunho: { rotulo: 'Rascunho', classes: 'bg-secondary-100 text-secondary-700' },
  publicado: { rotulo: 'Publicado', classes: 'bg-accent-100 text-accent-900' },
  encerrado: { rotulo: 'Encerrado', classes: 'bg-secondary-100 text-secondary-700' },
  cancelado: { rotulo: 'Cancelado', classes: 'bg-danger-100 text-danger-700' },
  arquivado: { rotulo: 'Arquivado', classes: 'bg-secondary-100 text-secondary-700' },
};

// "Os mais próximos primeiro": eventos futuros por proximidade crescente,
// depois os passados pelo mais recente.
export function ordenarEventos(eventos: EventoMeu[]): EventoMeu[] {
  const agora = Date.now();
  return [...eventos].sort((a, b) => {
    const aFuturo = new Date(a.inicio_em).getTime() >= agora;
    const bFuturo = new Date(b.inicio_em).getTime() >= agora;
    if (aFuturo !== bFuturo) return aFuturo ? -1 : 1;

    const ta = new Date(a.inicio_em).getTime();
    const tb = new Date(b.inicio_em).getTime();
    return aFuturo ? ta - tb : tb - ta;
  });
}

function contar(n: number, singular: string, plural: string): string {
  return `${n} ${n === 1 ? singular : plural}`;
}

// Um contador por tipo de evento. "Inscritos" nunca aparece em quem vende ficha,
// e equipe nunca soma com campista (nem inclui suplentes).
export function textoDoContador(evento: EventoMeu): string {
  if (evento.so_divulgacao) return 'Venda pelo WhatsApp';

  // Entrada franca que vende fichas: o número é de quem comprou ficha, nunca de ingresso.
  const vendeFichas =
    evento.entrada_franca === true || (!evento.vende_ingressos && !evento.usa_equipes);
  if (vendeFichas) {
    const n = evento.compradoresFichas;
    if (n === null || n === undefined) return '';
    return contar(n, 'comprador', 'compradores');
  }

  if (evento.vende_ingressos) {
    return contar(evento.inscritos, 'ingresso vendido', 'ingressos vendidos');
  }

  // Acampamento: com vaga e suplentes separados, equipe fora da conta de campista.
  const v = evento.vagas;
  if (!v) return '';
  if (v.equipeComVaga > 0 || v.campistasComVaga > 0) {
    return [
      v.campistasComVaga > 0
        ? `${contar(v.campistasComVaga, 'campista', 'campistas')} com vaga`
        : null,
      v.equipeComVaga > 0 ? contar(v.equipeComVaga, 'pessoa na equipe', 'equipe') : null,
    ]
      .filter(Boolean)
      .join(' · ');
  }
  return [
    v.totalComVaga > 0 ? `${v.totalComVaga} ${v.palavra} com vaga` : null,
    v.totalSuplentes > 0 ? contar(v.totalSuplentes, 'suplente', 'suplentes') : null,
  ]
    .filter(Boolean)
    .join(' · ');
}

// O cartão do acampamento precisa de uma palavra para "N ___ com vaga".
// "Casais" é o único grupo que já aparece assim no painel; o resto é "inscritos".
export function palavraDoGrupo(nomes: string[]): string {
  const juntos = nomes
    .join(' ')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  return juntos.includes('casai') ? 'casais' : 'inscritos';
}